import { Cookies } from 'react-cookie';
import BaseUrlApis from "./base.api";
import LoginApis from './login.api';
import { ConvertApis } from './convert.api';
import { PlatformApis } from './platform.api'
import { AppStoreCloudApis } from "./appstore.cloud.api";
import { download, downloadUrl, getFileBufferByUrl } from "./download.api";
import { MessageUtil, FROM_TYPE } from './utils/Message.util'
import CollaborationApiAdapter from './adapter/CollaborationApiAdapter'
import DocCollaborationApi from './collaboration/DocCollaborationApi'
import CollaborationApi from './CollaborationApi'
import PluginStoreApi from './PluginStoreApi';
import IDoxApis from './idox.api'
import ClientApi from './client.api';
import IManageApi from './IManageApi'
import ThirdPartyApi from './ThirdPartyApi';

//
import {
  DATA_TYPE, CONVERT_TYPE,
  isPathMatchValidPage, isNeedAutoSignIn, isAvoidAutoSignIn,
  TASK_STATUS, isMobile,isSharedClound
} from "./constants";
// bean
import { FileData } from "./bean/FileData";
import { createHtml2PDFParam } from './bean/Html2PDF.param'
import { CompressParams } from "./bean/Optimizer.param";
import { Task } from "./bean/Task";
import GoogleAnalyticsApis from './GoogleAnalytics.api'
import OtelApi from './otel.api'
import FoxitSignApis from './foxit_sign.api'
import MSForTeamsAppApi from 'Api/ms_api_for_teams_app.api';
import ESignChinaApi from 'Api/e_sign_china.api';
import StorageAppApi from 'Api/storage_app.api';
import PaymentApi from 'Api/payment.api';
import LMSApi from 'Api/lms.api';
import WanFangPaperCheckApis from 'Api/wan_fang_paper_check.api';

const cookies = new Cookies();
const baseUrlApis = new BaseUrlApis();
const loginApis = new LoginApis();
const convertApis = new ConvertApis();
const platformApis = new PlatformApis();
const appStoreCloudApis = new AppStoreCloudApis();
//const serverConfigApi = new ServerConfigApi();
const googleAnalyticsApis = new GoogleAnalyticsApis();
const windowMessageUtil = new MessageUtil();
const otelApi = new OtelApi()
const foxitSignApi = new FoxitSignApis()
const collaborationApiAdapter = new CollaborationApiAdapter()
const collaborationApi = new CollaborationApi()
const docCollaborationApi = new DocCollaborationApi()
const pluginStoreApi = new PluginStoreApi();
const msForTeamsAppApi = new MSForTeamsAppApi()
const eSignChinaApi = new ESignChinaApi()
const iDoxApis = new IDoxApis();
const clientApi = new ClientApi();
const iManageApi = new IManageApi();
const storageAppApi = new StorageAppApi();
const paymentApi = new PaymentApi();
const lmsApi = new LMSApi();
const thirdPartyApi = new ThirdPartyApi()
const wanFangPaperCheckApi = new WanFangPaperCheckApis();

window.otelApi = otelApi;
window.__cookies = cookies;

export {
  pluginStoreApi,
  docCollaborationApi,
  collaborationApi,
  collaborationApiAdapter,
  TASK_STATUS,
  cookies,
  baseUrlApis,
  loginApis,
  convertApis,
  platformApis,
  appStoreCloudApis,
  googleAnalyticsApis,
  FileData,
  Task,
  DATA_TYPE,
  CONVERT_TYPE,
  download,
  downloadUrl,
  getFileBufferByUrl,
  createHtml2PDFParam,
  isPathMatchValidPage,
  isSharedClound,
  isNeedAutoSignIn,
  isAvoidAutoSignIn,
  CompressParams,
  isMobile,
  otelApi,
  foxitSignApi,
  //serverConfigApi
  //
  windowMessageUtil, FROM_TYPE,
  msForTeamsAppApi,
  eSignChinaApi,
  iDoxApis,
  clientApi,
  iManageApi,
  storageAppApi,
  paymentApi,
  lmsApi,
  thirdPartyApi,
  wanFangPaperCheckApi,
};
